import { InvitesExportType } from "../components/invites-export/invites-export.types";

export const MODULE_NAME = "InviteStatus";

export const INVITES_EXPORT_DELIMITER: Partial<Record<InvitesExportType, string>> = {
  [InvitesExportType.tabDelimited]: "\t",
  [InvitesExportType.commaDelimited]: ",",
  [InvitesExportType.xls]: ",",
  [InvitesExportType.xlsx]: ",",
};